import { CustomForm } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  publicLinkId: string;
  form: CustomForm;
}


interface ResponseDataType {
  is_task_queued: boolean;
  is_form_attached_to_record: boolean;
  new_signer_names: string[] | null;
  pdf_file_url: string | null;
}

export const fillPublicLinkCustomFormReportFormRequest = ({
                                                            publicLinkId,
                                                            form,
                                                          }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-report/public-link/${ publicLinkId }/fill-form`, {
    method: 'PUT',
    body: form,
  });
};